import { apiFetch } from './api-fetch.js'

/**
 * Send assertion failure to the server
 * @param {Object} assertInfo - Assertion information
 * @param {string} assertInfo.location - Location where assertion failed
 * @param {string} assertInfo.message - Assertion failure message
 * @param {any} assertInfo.data - Additional data about the failure
 * @param {string} assertInfo.stack - Stack trace
 * @param {number} assertInfo.timestamp - Unix timestamp
 * @param {string} assertInfo.userAgent - Browser user agent
 * @param {string} assertInfo.url - Current page URL
 * @returns {Promise<{status: string, message: string}>}
 */
export async function sendAssert(assertInfo) {
  return apiFetch('/assert', 'POST', assertInfo).then(r => r.json())
}